import type { ReactElement } from 'react';
import { Box, Text } from '@mantine/core';
import { UserCheck } from 'lucide-react';
import PageLevelFilterRow from '@/shared/surfaces/PageLevelFilterRow';
import PageHeaderComponent from '@/design/PageHeaderComponent';
import SurfaceAssistScope, { SurfaceAssistToolbar } from '@/shared/surfaces/assist/SurfaceAssistScope';
import { useSurface } from '@/shared/surfaces/useSurface';
import TopicNotFound from '@/shared/surfaces/TopicNotFound';
import GovernanceIssuesTab from './GovernanceIssuesTab';

/** Governance › Assigned to Me: the issue tracker filtered to the signed-in user's assignments. */
export default function GovernanceAssignedPage(): ReactElement {
    const surface = useSurface('governance');
    if (surface === undefined) return <TopicNotFound />;

    return (
        <SurfaceAssistScope surface={surface}>
            <Box pb="xl">
                <PageLevelFilterRow inactive inactiveNote="Not applied — issues list all open findings" assist={<SurfaceAssistToolbar surface={surface} />} />

                <PageHeaderComponent
                    icon={UserCheck}
                    eyebrow="Governance"
                    title="Assigned to Me"
                    subtitle="Governance issues assigned to you — triage them here."
                />

                <Text size="sm" c="dimmed" mb="md">
                    Open a row to add notes, resolve, and review the audit trail.
                </Text>
                <GovernanceIssuesTab mineOnly />
            </Box>
        </SurfaceAssistScope>
    );
}
